import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { getCustomerTypes } from '../../../dave-data-module/State/selectors/customers.selectors';
import { CustomerTypeEntity } from '../../../dave-data-module/entities/customer-type.entity';
import { Store } from '@ngrx/store';
import { State } from '../../../dave-data-module/State';

@Component({
    selector: 'app-detail-filter',
    templateUrl: './detail-filter.component.html',
    styleUrls: ['./detail-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailFilterComponent<T extends {CustomerTypeIds: number []}> implements OnInit, OnChanges {
    @Input() FilterOpen = false;
    @Output() FilterOpenChange = new EventEmitter();

    @Input() CustomersInput: T[];
    @Output() FilteredCustomersOutput = new EventEmitter<T[]>(true);

    public CustomerTypeFilter: CustomerTypeEntity[] = [];
    public CustomerTypes$: Observable<CustomerTypeEntity[]>;

    constructor(private store: Store<State>) {
        this.CustomerTypes$ = this.store.select(getCustomerTypes);
    }

    ngOnInit() {
        this.FilteredCustomersOutput.emit(this.CustomersInput);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.CustomersInput) {
            this.filterCustomers();
        }
    }
    public CustomerTypeToggleFilterArraysEmpty() {
        if (this.CustomerTypeFilter.length) {
            this.CustomerTypeFilter = [];
        } else {
            this.CustomerTypes$.pipe(take(1)).subscribe(value => (this.CustomerTypeFilter = value));
        }
    }

    public Filter() {
        if (this.CustomersInput) {
            this.filterCustomers();
        }
    }
    public ResetFilter() {
        if (this.CustomersInput) {
            this.CustomerTypeFilter = [];
        }
        this.Filter();
        this.FilterOpenChange.emit(!this.FilterOpen);
    }
    private filterCustomers() {
        this.FilteredCustomersOutput.emit(
            this.CustomersInput.filter(c =>
                !this.CustomerTypeFilter.length || c.CustomerTypeIds.some(
                    ctId => !!this.CustomerTypeFilter.find(ctf => ctf.Id === ctId),
                ),
            ),
        );
    }
}
